class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

        // JF 2026-10-01 (SPEED 6): record the key once its script has been added. The components behind these keys
        // (product-card, theme-modal, product-media, deferred-media) never call webcomponentRegistry.register(), so every
        // <safe-load-scripts> on the page appended another copy of the same module tag (about 170 on a search page, 39 on
        // the home page). Modules only run once, so this changes nothing visible; keyless scripts still load every time.
        if (key) {
          window.wetheme.webcomponentRegistry.register({ key: key });
        }
      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);